import React from "react";

const siblings = 3; // pages on each side of current

const Pagination = ({ setShowPerPage, showPerPage, totalPosts }) => {
  const totalPages = Math.ceil(totalPosts / 10);

  const createPagesToRender = () => {
    const pages = [];

    if (totalPages <= 7) {
      // Show all pages if 7 or less
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
      return pages;
    }

    const firstPage = 1;
    const lastPage = totalPages;

    pages.push(firstPage);

    let leftSibling = showPerPage - siblings;
    let rightSibling = showPerPage + siblings;

    if (leftSibling <= 2) {
      leftSibling = 2;
      rightSibling = leftSibling + 2 * siblings;
    }

    if (rightSibling >= totalPages - 1) {
      rightSibling = totalPages - 1;
      leftSibling = rightSibling - 2 * siblings;
    }

    if (leftSibling > 2) {
      pages.push("left-ellipsis");
    }

    for (let i = leftSibling; i <= rightSibling; i++) {
      pages.push(i);
    }

    if (rightSibling < totalPages - 1) {
      pages.push("right-ellipsis");
    }

    pages.push(lastPage);

    return pages;
  };

  const pagesToRender = createPagesToRender();

  const changePage = (page) => {
    if (page === "left-ellipsis") {
      setShowPerPage(Math.max(1, showPerPage - siblings * 2));
    } else if (page === "right-ellipsis") {
      setShowPerPage(Math.min(totalPages, showPerPage + siblings * 2));
    } else {
      setShowPerPage(page);
    }
  };

  return (
    <nav aria-label="Page navigation" style={{ width: "100%" }}>
      <ul className="pagination display mt-3">
        <li className="page-item previous">
          <a
            className="page-link"
            onClick={() =>
              setShowPerPage((prev) => (prev > 1 ? prev - 1 : prev))
            }
          >
            Previous
          </a>
        </li>

        {pagesToRender.map((page, index) => (
          <li
            className={`page-item ${page === "left-ellipsis" || page === "right-ellipsis" ? "disabled" : ""}`}
            key={index}
          >
            <a
              className={`page-link ${showPerPage === page ? "active" : ""}`}
              onClick={() => changePage(page)}
            >
              {page === "left-ellipsis" || page === "right-ellipsis" ? "…" : page}
            </a>
          </li>
        ))}

        <li className="page-item next">
          <a
            className="page-link active"
            onClick={() =>
              setShowPerPage((prev) => (prev < totalPages ? prev + 1 : prev))
            }
          >
            Next
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
